// import logo from "./logo.svg";
// import "./App.css";
import DashboardPage from "./pages/DashboardPage";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import LoginPage from "./pages/LoginPage";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import setDarkTheme from "./theme/darkTheme";
import setLightTheme from "./theme/lightTheme";
import extraPalettes from "./theme/common";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

export default function App() {
  const isDarkMode = useSelector((state) => state.theme.isDarkMode);
  const paletteNum = useSelector((state) => state.theme.customPaletteNum);
  const setThemeMode = () =>
    isDarkMode
      ? setDarkTheme(extraPalettes[paletteNum])
      : setLightTheme(extraPalettes[paletteNum]);

  React.useEffect(() => {
    localStorage.setItem("customPaletteNum", paletteNum);
  }, [paletteNum]);

  React.useEffect(() => {
    localStorage.setItem("isDarkMode", isDarkMode);
  }, [isDarkMode]);

  return (
    <ThemeProvider theme={setThemeMode()}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />

          <Route path="/login" element={<LoginPage />} />

          <Route path="/dashboard" element={<DashboardPage />} />
          <Route
            path="*"
            element={
              <main style={{ padding: "1rem" }}>
                <p>There's nothing here!</p>
              </main>
            }
          />
        </Routes>
      </Box>
    </ThemeProvider>
  );
}
